import z from "zod";

export const substitutionPlanPersonSchema = z.object({
	id: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	email: z.email().nullish(),
});

export const substitutionPlanSummaryItemSchema = z.object({
	projectName: z.string(),
	projectNumber: z.string().nullish(),
	quickNote: z.string().nullish(),
	substitutions: z.array(substitutionPlanPersonSchema),
	contacts: z.array(substitutionPlanPersonSchema),
});

export const substitutionPlanSummarySchema = z.object({
	items: z.array(substitutionPlanSummaryItemSchema),
});

export type SubstitutionPlanSummarySchema = z.infer<typeof substitutionPlanSummarySchema>;
export type SubstitutionPlanSummaryItemSchema = z.infer<typeof substitutionPlanSummaryItemSchema>;
